import { useTranslation } from 'react-i18next';

import { useDeleteQuotation } from '~/api/quotations';
import { AlertDialog, Button } from '~/components';
import { toast } from '~/utils/toast';

type Props = {
  onClose: () => void;
  quotationId: number;
};

export const ConfirmDeleteQuotationDialog = ({ onClose, quotationId }: Props) => {
  const { t } = useTranslation(['common', 'quotations']);

  const mutation = useDeleteQuotation(quotationId);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('common:draft.deleteModal.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('common:draft.deleteModal.description')}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button
          emphasis="status"
          icon="Trash"
          loading={mutation.isPending}
          onClick={() =>
            mutation.mutate(undefined, {
              onSuccess: () => {
                toast.success({ description: t('quotations:alerts.successDeleted') });
                onClose();
              },
              onError: () => toast.danger({ description: t('common:error') }),
            })
          }
        >
          {t('common:draft.deleteModal.submit')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
